import { useState } from "react";
import { Box, List, ListItem, ListItemText, ListItemIcon } from "@mui/material";
import { PrimaryButton, PrimaryButtonText } from "../../components/ui/Button";
import { ArrowBack, ArrowForward } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  authSelector,
  setUserAuth,
  setUserBusinessType,
  setUserLoanCategory,
  setUserPermission,
} from "../../services/redux/slices/authSlice";
import { RadioButton } from "../../components/ui/RadioButton";
import service from "../../services/api/service";
import {
  setStatusPopup,
} from "../../services/redux/slices/statusPopupSlice"; import { capitalizeFirstLetter } from "../../utils/helpers";
import { encrypt } from "../../utils/crypto";
import ButtonLoader from "../../components/ui/ButtonLoader";
import { ReactComponent as UserIcon } from "../../assets/images/icons/userone.svg";
import { ReactComponent as UserIconNew } from "../../assets/images/icons/usernew.svg";
import { ReactComponent as UserIconTwo } from "../../assets/images/icons/usertwo.svg";
import { ReactComponent as UserIconThree } from "../../assets/images/icons/building-skyscraper.svg";
import { ReactComponent as UserIconFour } from "../../assets/images/icons/building-skyscraper-one.svg";
import { setSelectedIndex, setTabType } from '../../services/redux/slices/tabsSlice';
import { RootState } from '../../services/redux/store';
import { UAParser } from 'ua-parser-js';
import { setIsShowReferralBanner } from "../../services/redux/slices/dashboardDataSlice";

type props = {
  setNextStep: (step: string) => void;
  // Carries the password entered on EnterPassword — see Router.tsx's
  // pendingLoginPassword — kept outside Redux so it's never in the globally
  // inspectable store.
  pendingLoginPassword: string;
  setPendingLoginPassword: (password: string) => void;
};


const LoginType = ({ setNextStep, pendingLoginPassword, setPendingLoginPassword }: props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { userProfile, businessType } = useSelector(authSelector);
  const tabType = useSelector((state: RootState) => state.tabs.tabType);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedLoginId, setSelectedLoginId] = useState<null | number>(null);

  // Utility to get or create a persistent deviceId
  const getOrCreateDeviceId = () => {
    let deviceId = localStorage.getItem('deviceId');
    if (!deviceId) {
      deviceId = crypto.randomUUID();
      localStorage.setItem('deviceId', deviceId);
    }
    return deviceId;
  };

  const getUserAgentDetails = () => {
    const parser = new UAParser();
    return {
      browser: parser.getBrowser(),
      engine: parser.getEngine(),
      os: parser.getOS(),
      device: parser.getDevice(),
      cpu: parser.getCPU(),
      ua: parser.getUA(),
    };
  };


  const handleSelectLogin = (id: number) => {
    setIsLoading(true);
    const selectedBusinessType = businessType.find(
      (loan: any) => loan?.id === id
    );

    const userDetails = getUserAgentDetails();
    const deviceId = getOrCreateDeviceId();
    const deviceInfo = JSON.stringify({
      browser: userDetails.browser,
      os: userDetails.os,
      device: userDetails.device,
      ua: userDetails.ua,
    });
    const deviceName = `${userDetails?.browser?.name || 'UnknownBrowser'}-${userDetails?.os?.name || 'UnknownOS'}-${userDetails?.device?.model || 'Desktop'}`;
    let checkBusinessId =process.env.REACT_APP_PAYLOAD_ENCRYPTION != "true" && process.env.REACT_APP_LOAD_TESTING=="true";
    const payload = {
      businessId: checkBusinessId ? "1" : encrypt(id?.toString()),
      id: userProfile?.id?.toString(),
      password: encrypt(pendingLoginPassword?.toString()),
      deviceId,
      deviceInfo,
      deviceName,
    };
    service?.auth
      ?.setLogin(payload)
      .then((response) => {
        const token = response?.data?.data?.token;
        const permissionObj = response?.data?.data?.permission;
        const loanCategoryObj = response?.data?.data?.result;
        dispatch(setUserAuth(token));
        dispatch(setUserPermission(permissionObj));
        dispatch(setUserBusinessType(selectedBusinessType));
        dispatch(setSelectedIndex(0));
        if(loanCategoryObj?.Flexi?.length > 0 || loanCategoryObj?.TermLoan?.length > 0) {
          dispatch(setIsShowReferralBanner(true))
        }
        if(loanCategoryObj?.Flexi?.length > 0 && loanCategoryObj?.TermLoan?.length > 0){
         dispatch(setTabType("Term Loan"));
        }else{
          if(selectedBusinessType?.name === "entity" && loanCategoryObj?.Flexi?.length <= 0 ){
            dispatch(setTabType("Term Loan"));
          }else if (selectedBusinessType?.name === "entity") {
            dispatch(setTabType("Flexi Term Loan"));
          } else if (selectedBusinessType?.name === "retail") {
            dispatch(setTabType("Term Loan"));
          } else {
            dispatch(setTabType("Term Loan"));
          }
        }

        dispatch(setUserLoanCategory(loanCategoryObj));
        setPendingLoginPassword("");
        setIsLoading(false);
      })
      .catch((error) => {
        const errorMessage =
          error.response?.data?.message || "An error occurred";
        dispatch(
          setStatusPopup({
            status: "error",
            message: errorMessage,
          })
        );
        setIsLoading(false);
      });
  };
  // const UserIconThree = styled("img")({
  //   width: 47,
  //   height: "auto",
  // });
  const businessTypeLabel = (businessType: string) => {
    if (businessType?.includes('retail'))
      return 'Login as Individual';
    else if (businessType?.includes('entity'))
      return 'Login as Institutional';
    else
      return `Login as ${capitalizeFirstLetter(businessType)}`
  }

  const handleBack = () => {
    setNextStep("")
  }

  return (
    <Box>
      <Box className="main-wrapper">
        <PrimaryButtonText
          startIcon={<ArrowBack color="inherit" fontSize="small" />}
          onClick={handleBack}
        >
          Back
        </PrimaryButtonText>
        <Box className="head-section">

          <Box className="heading">Select Login As</Box>
          <Box className="sub-heading">
            We've identified the following login Type
          </Box>
        </Box>
        <List aria-label="profile list" style={{ width: "100%", padding: "0px" }}>
          {businessType?.length > 1 &&
            businessType?.map((login: any) => (
              <Box
                key={login?.id}
                component="section"
                height="55px"
                my={1}
                pl={0}
                display="flex"
                alignItems="left"
                sx={{
                  border: "1px solid #1CB1B1",
                  borderRadius: "8px",
                  backgroundColor:
                    selectedLoginId === login?.id ? "#D3F8F8" : "transparent",
                }}
              >
                {selectedLoginId === login?.id ?
                  <Box className="user-box">
                    {login?.name === "retail" ? <UserIcon
                    /> : <UserIconFour
                    />}
                  </Box> : <Box className="user-box-two">
                    {login?.name === "retail" ? <UserIconNew
                    /> : <UserIconThree
                    />}
                    {/* <img src={UserIconThree}/> */}
                  </Box>}
                <ListItem
                  button
                  onClick={() => setSelectedLoginId(login?.id)}
                  sx={{ paddingRight: "0px" }}
                >
                  <ListItemText
                    className="text-lable"
                    primary={businessTypeLabel(login?.name)}
                  />
                  <ListItemIcon>
                    <RadioButton
                      checked={selectedLoginId === login?.id}
                      onChange={() => setSelectedLoginId(login?.id)}
                    />
                  </ListItemIcon>
                </ListItem>
              </Box>
            ))}
        </List>

        <PrimaryButton
          type="button"
          onClick={() =>
            selectedLoginId != null && handleSelectLogin(selectedLoginId)
          }
          fullWidth
          disabled={!selectedLoginId || isLoading}
        >
          <ButtonLoader title="Continue" isLoading={isLoading} />
        </PrimaryButton>
      </Box>
    </Box>
  );
};

export default LoginType;
